var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"standard-page v-flex"},[_c('iframe',{attrs:{"src":_vm.transactionReportURL,"referrerpolicy":"unsafe-url","height":"100%","width":"100%","title":"magic iframes for kids"}})])}
var staticRenderFns = []

export { render, staticRenderFns }